<template>
    <base-modal :visible="visible" @close="close" title="Invite user">
        <template v-if="success">
            <div class="notification is-success">
                User was successfully invited to space <b>{{space.name}}</b>!
            </div>

            <base-button
                @click="success = false"
                :loading="create.loading"
                class="is-primary"
                icon="fas fa-user-plus"
                text="Invite more users"/>

            <base-button @click="close" class="is-danger"> Close </base-button>
        </template>

        <template v-else>
            <base-backend-errors :data="create.error"/>
            <div class="columns">
                <div class="column">
                    <base-input v-model="form.email" name="email" type="email" validate="required"
                                icon="fas fa-envelope" placeholder="Email address"/>
                </div>

                <div class="column is-narrow">
                    <base-select
                        v-model="form.role"
                        :options="roles"
                        option_value="value"
                        option_label="label"/>
                </div>
            </div>

            <base-button
                @click="send"
                :loading="create.loading"
                class="is-primary"
                icon="fas fa-user-plus"
                text="Invite"/>
        </template>

    </base-modal>
</template>

<script>
import { mapState } from 'vuex';
import { roles } from '../../utils/constants';

export default {
    name: 'InviteModal',
    props: ['space', 'visible'],
    data() {
        return {
            form: { email: null, role: 'readonly' },
            roles,
            success: false,
        };
    },
    computed: mapState('invitation', ['create']),
    methods: {
        send() {
            this.$validator.validate().then((result) => {
                if (!result) return;
                this.$store.dispatch('invitation/create', {
                    space_id: this.space.id,
                    data: this.form,
                }).then(() => {
                    this.success = true;
                    this.form = { email: null, role: 'readonly' };
                });
            });
        },
        close() {
            // Reset component state
            Object.assign(this.$data, this.$options.data());
            this.$emit('close');
        },
    },
};
</script>
